import type { UseQueryResult } from "@tanstack/react-query";

import { useOrgScopedQuery } from "../../query/scope";
import {
  getCiLogConnection,
  getCiLogProviders,
  getCiLogStatus,
  type CiLogConnection,
  type CiLogProvider,
  type CiLogStatus,
} from "./ciLogsApi";

// Хуки секции «CI-логи». Org-scoped запросы (см. `src/query/scope.ts`),
// `retry: false` — на 401/403/502 повторяем по кнопке, не сами.

/** Смысловая часть ключа кэша подключения (без скоуп-сегмента). */
export const CI_LOG_CONNECTION_KEY = [
  "connections",
  "ci-logs",
  "connection",
] as const;

/** Смысловая часть ключа кэша живого статуса (без скоуп-сегмента). */
export const CI_LOG_STATUS_KEY = ["connections", "ci-logs", "status"] as const;

export function useCiLogProviders(): UseQueryResult<
  readonly CiLogProvider[],
  Error
> {
  return useOrgScopedQuery<readonly CiLogProvider[]>({
    key: ["connections", "ci-logs", "providers"],
    queryFn: () => getCiLogProviders(),
    retry: false,
  });
}

export function useCiLogConnection(): UseQueryResult<CiLogConnection, Error> {
  return useOrgScopedQuery<CiLogConnection>({
    key: CI_LOG_CONNECTION_KEY,
    queryFn: () => getCiLogConnection(),
    retry: false,
  });
}

/** Живой отчёт о доступности; включается только при `connected`. */
export function useCiLogStatus(
  enabled: boolean,
): UseQueryResult<CiLogStatus, Error> {
  return useOrgScopedQuery<CiLogStatus>({
    key: CI_LOG_STATUS_KEY,
    queryFn: () => getCiLogStatus(),
    retry: false,
    enabled,
  });
}
